import React from 'react';
import { ApolloError } from '@apollo/client/errors';
import Item from './Scenes/Item';
import Upsales from './Scenes/Upsales';
import { SCENES, UpsalesQuantity } from './';
import { GetItem_item_upsales } from './__queries__';
import { FormattedModificationGroup } from 'Hooks/ItemModifications/useItemModifications';

type Props = {
  activeScene: string;
  itemImage: string | undefined;
  itemTitle: string;
  itemDescription: string;
  itemMaxQuantity?: number;
  allRequiredVariationsSelected: boolean;
  isLoggedIn: boolean;
  loading: boolean;
  allergyTags?: string[];
  modificationGroups: FormattedModificationGroup[];
  onSelectVariationId: (id: string) => void;
  onItemButton: () => void;
  total: number;
  quantity: string;
  onChangeQuantity: (quantity: string) => void;
  error: ApolloError | undefined;
  showLoginModal: boolean;
  upsalesStep: number;
  setUpsalesStep: React.Dispatch<React.SetStateAction<number>>;
  onUpsalesButton: () => void;
  upsales: GetItem_item_upsales[];
  upsalesQuantity: UpsalesQuantity[];
  onChangeUpsalesQuantity: (groupId: string, id: string, quantity: string) => void;
  isMenuExpired: boolean;
  onConfirmMenuExpired: () => void;
};

const View = ({
  activeScene,
  itemImage,
  itemTitle,
  itemDescription,
  itemMaxQuantity,
  allRequiredVariationsSelected,
  isLoggedIn,
  loading,
  onItemButton,
  allergyTags,
  modificationGroups,
  onSelectVariationId,
  total,
  quantity,
  onChangeQuantity,
  error,
  showLoginModal,
  upsalesStep,
  setUpsalesStep,
  onUpsalesButton,
  upsales,
  upsalesQuantity,
  onChangeUpsalesQuantity,
  isMenuExpired,
  onConfirmMenuExpired,
}: Props) => {
  if (activeScene === SCENES.ITEM) {
    return (
      <Item
        allergyTags={allergyTags}
        modificationGroups={modificationGroups}
        itemImage={itemImage}
        itemTitle={itemTitle}
        itemDescription={itemDescription}
        itemMaxQuantity={itemMaxQuantity}
        allRequiredVariationsSelected={allRequiredVariationsSelected}
        onSelectVariationId={onSelectVariationId}
        onItemButton={onItemButton}
        total={total}
        quantity={quantity}
        onChangeQuantity={onChangeQuantity}
        showLoginModal={showLoginModal}
        error={error}
        isLoggedIn={isLoggedIn}
        loading={loading}
        isMenuExpired={isMenuExpired}
        onConfirmMenuExpired={onConfirmMenuExpired}
      />
    );
  }

  if (activeScene === SCENES.UPSALES) {
    return (
      <Upsales
        groups={upsales}
        upsalesQuantity={upsalesQuantity}
        itemQuantity={quantity}
        step={upsalesStep}
        setStep={setUpsalesStep}
        onSubmit={onUpsalesButton}
        onChangeQuantity={onChangeUpsalesQuantity}
      />
    );
  }
  return null;
};

export default View;
